/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconJob16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconJob16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.733 3.992c1.746 0 2.018 0 2.659.392.359.22.66.52.88.878.268.435.353.977.38 1.827h.013v2.926c-.254.071-.518.136-.791.195 0 1.7-.005 2.556-.393 3.188-.22.358-.522.658-.88.878-.642.391-1.515.391-3.26.391H6.406c-1.746 0-2.619 0-3.26-.391-.359-.22-.66-.52-.88-.878-.393-.64-.393-1.51-.393-3.25v-.012a16.97 16.97 0 0 1-.542-.12V7.088h.013c.027-.85.113-1.392.38-1.827.22-.358.522-.659.88-.878.642-.392.914-.392 2.66-.392.023-1.492 1.259-2.658 2.734-2.658s2.71 1.166 2.734 2.658ZM8 2.684c-.779 0-1.377.601-1.4 1.308h2.8c-.023-.707-.621-1.308-1.4-1.308Zm2.133 2.638H5.865c-.898 0-1.479 0-1.918.043-.419.04-.569.106-.645.152-.18.11-.33.26-.44.44-.047.075-.114.225-.154.643-.041.437-.043 1.016-.043 1.912v.422c1.201.213 2.67.367 4.219.428l.448-1.34h1.333l.455 1.36c1.509-.035 2.966-.168 4.212-.417v-.453c0-.896-.001-1.475-.043-1.912-.04-.418-.107-.568-.153-.644a1.33 1.33 0 0 0-.44-.439c-.077-.046-.227-.113-.646-.152-.439-.042-1.02-.043-1.918-.043ZM3.25 12.06c-.038-.4-.042-.92-.043-1.693 1.117.162 2.38.276 3.685.325l.44 1.317h1.333l.434-1.298a29 29 0 0 0 3.441-.264c0 .73-.006 1.226-.043 1.613-.04.418-.107.568-.153.643-.11.18-.26.33-.44.44-.076.046-.227.112-.646.152-.438.042-1.019.043-1.918.043H6.407c-.899 0-1.48-.001-1.918-.043-.419-.04-.57-.106-.645-.153-.18-.11-.33-.26-.44-.439-.047-.075-.114-.225-.154-.643Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconJob24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconJob24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.102 5.988c2.619 0 3.026 0 3.988.587.538.329.99.78 1.32 1.317.402.652.53 1.465.57 2.74H22v4.39c-.381.106-.778.204-1.188.293 0 2.548-.007 3.834-.589 4.78-.33.538-.782.989-1.32 1.317-.962.588-2.272.588-4.89.588h-4.4c-2.62 0-3.929 0-4.89-.588a3.993 3.993 0 0 1-1.321-1.316c-.59-.959-.59-2.264-.59-4.875v-.018A24.787 24.787 0 0 1 2 15.022v-4.39h.02c.04-1.275.168-2.088.57-2.74.33-.537.782-.988 1.32-1.317.962-.587 1.37-.587 3.988-.587C7.934 3.749 9.788 2 12 2c2.213 0 4.066 1.75 4.102 3.988ZM12 4.026c-1.168 0-2.065.901-2.1 1.962H14.1c-.035-1.061-.933-1.962-2.1-1.962Zm3.2 3.955H8.8c-1.348 0-2.219.002-2.877.065-.629.06-.854.16-.968.23-.27.164-.495.39-.66.657-.07.114-.17.339-.23.965-.063.657-.065 1.524-.065 2.868v.634c1.802.32 4.004.55 6.327.642l.672-2.01h2l.683 2.04c2.263-.052 4.448-.252 6.318-.625v-.68c0-1.345-.002-2.212-.065-2.869-.06-.626-.16-.851-.23-.965a1.998 1.998 0 0 0-.66-.658c-.114-.07-.34-.17-.968-.23-.658-.062-1.529-.064-2.877-.064ZM4.877 18.09c-.057-.601-.064-1.38-.064-2.54a52.88 52.88 0 0 0 5.526.489l.66 1.974h2l.651-1.946a43.535 43.535 0 0 0 5.162-.396c0 1.094-.009 1.84-.064 2.42-.06.626-.16.85-.23.964a1.998 1.998 0 0 1-.66.658c-.114.07-.34.17-.968.23-.659.062-1.53.064-2.878.064h-4.4c-1.348 0-2.218-.002-2.877-.064-.628-.06-.854-.16-.967-.23a1.997 1.997 0 0 1-.66-.658c-.07-.113-.171-.338-.23-.965Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconJob = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconJob(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconJob16 {...iconProps} />;
        case '24':
            return <IconJob24 {...iconProps} />;
        default:
            return <IconJob24 {...iconProps} />;
    }
});
